import type { DevState } from 'app/store/dev/dev.state';
import type { Uuid } from 'shared/common/types';
import { createSelector } from '@ngrx/store';
import { selectDevState } from 'app/store/dev/dev.state';
import * as fromCouriers from './couriers.reducer';

export const devCouriersState = createSelector(
  selectDevState,
  state => state.couriers,
);

export const devCouriers = createSelector(
  selectDevState,
  state => fromCouriers.selectAll(state.couriers),
);

export const oneDevCourier = createSelector(
  selectDevState,
  (state: DevState, props: { id: Uuid }) => fromCouriers.selectEntities(state.couriers)[props.id],
);

export const integrationClasses = createSelector(
  selectDevState,
  state => state.couriers.integrationClasses,
);
